import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import { Dropdown } from 'semantic-ui-react'

const SelectInput = (props) => {
    const {
        input,
        label,
        optionsData,
        placeHolder,
        require,
        multiple,
        clearable = false,
        halfRow = false,
        disabled = false,
        meta: { touched, error }

    } = props
    const customStyle = {
        backgroundColor: '#ffcc00 !important', // เปลี่ยนสีพื้นหลัง
        color: '#333', // เปลี่ยนสีตัวอักษร
        border: '2px solid #333', // เปลี่ยนสีเส้นขอบ
    };
    return (
        <div className={`${halfRow ? 'w-1/2' : 'w-full'} px-3`}>
            <label className="block  tracking-wide text-gray-800 font-bold text-sm  mb-2 text-left" >
                {label}
                {require ? <span className='ml-2 text-red-500 require'>*</span> : null}
                {touched && error ? <span className='ml-2 text-red-500 require'>{error}</span> : null}
            </label>
            <Dropdown
                // touched && error
                style={{ backgroundColor: disabled ? "#3b3b3b0a" : touched && error ? "#FFF0F0" : "" , borderColor:'#FBC558', opacity:1, lineHeight:'1.2'}}
                className={`w-full outline-none text-base border focus:outline-none border-[#FBC558] text-gray-800 rounded-lg text-left`}
                name={input.name}
                fluid
                search
                selection
                selectOnBlur={false}
                clearable={clearable}
                disabled={disabled}
                placeholder={placeHolder}
                additionPosition='bottom'
                // error={touched && error}
                value={input.value}
                options={optionsData}
                multiple={multiple !== undefined ? multiple : false}
                noResultsMessage={'No results found.'}
                onChange={(e, data) => {
                    input.onChange(data.value)
                }}
            />
        </div>

    )
}

const mapStateToProps = (state) => {

    return {

    }
}

const mapDispatchToProps = {

}


export default connect(mapStateToProps, mapDispatchToProps)(SelectInput)